import { motion } from 'framer-motion'

const features = [
  {
    number: '01',
    icon: '🚀',
    title: 'Fast Delivery',
    description: 'Get food delivered in 30 minutes or less from your favourite local spots.',
  },
  {
    number: '02',
    icon: '🍽️',
    title: 'Quality Restaurants',
    description: 'Partnered with 100+ local restaurants for fresh, delicious meals every time.',
  },
  {
    number: '03',
    icon: '📍',
    title: 'Live Order Tracking',
    description: 'Watch your order progress from kitchen to doorstep in real time.',
  },
]

export default function Features() {
  return (
    <section id="features" className="bg-[#0e0e0e] py-24 px-4">
      <div className="container-wide">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[0.7rem] font-bold tracking-[0.14em] uppercase text-white/30 mb-3">
            Why Munchies
          </p>
          <h2 className="text-[clamp(2rem,3.5vw,3rem)] font-black tracking-[-0.035em] text-white mb-4">
            Everything you need, in your browser
          </h2>
          <p className="text-[0.95rem] text-white/40 max-w-md mx-auto leading-relaxed">
            The same great experience as our mobile app — now accessible from any device, anywhere.
          </p>
        </motion.div>

        {/* Bento grid — 3 equal columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {features.map((feature, i) => (
            <motion.div
              key={feature.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative bg-[#191919] border border-white/[0.07] rounded-[20px] p-8 overflow-hidden transition-all duration-300 hover:-translate-y-0.5 hover:border-[#e8cc45]/35"
            >
              {/* Top glow on hover */}
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#e8cc45] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <p className="font-mono text-[0.65rem] font-semibold tracking-widest text-[#e8cc45]/70 mb-6">
                {feature.number}
              </p>
              <div className="w-10 h-10 rounded-[10px] bg-[#e8cc45]/10 border border-[#e8cc45]/15 flex items-center justify-center text-lg mb-5">
                {feature.icon}
              </div>
              <h3 className="text-base font-bold text-white tracking-tight mb-2">
                {feature.title}
              </h3>
              <p className="text-[0.85rem] text-white/40 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
